// Import SASS
import '../sass/style.scss'

// Node_modules
import objectFitImages from 'object-fit-images'
import AOS from 'aos'

// Import scripts
import './modules/skip-link-focus-fix'
import modals from './modules/modals.js';
import initYoutubeVideos from './modules/init-after-youtube-api' // when videos are loaded on the page

import '../partials/navigation/menus/menus'
// import '../partials/search/search'
import initSliders from '../partials/sliders/sliders'
import shrinky from './modules/shrinky'
import { initBlockSlider } from '../partials/blocks/block/block-slider'

import mixitup from 'mixitup';

import Typed from 'typed.js';

// Animate on scroll
AOS.init()

window.onYouTubeIframeAPIReady = function() {
	initYoutubeVideos();
}

// Object-fit fix
objectFitImages()

// Init slider
let sliders = initSliders();
console.log(sliders);


shrinky('.header', 50) // shrink header on scroll

modals.init( {
  backspaceClose: false,
  callbackOpen: function ( toggle, modal ) {

    var modal = document.querySelector(".modal");


    modal.classList.setAttribute("data-aos", "fade-up");

  },
  callbackClose: function ( toggle, modal ) {

    modal.classList.setAttribute("data-aos", "");

  }


} );

if (document.querySelector(".grid-teammembers")) { 
    var mixer = mixitup('.grid-teammembers', {
        animation: {
            animateResizeContainer: false
        }
    });
}

if (document.querySelector(".grid-deals")) { 
    var mixer = mixitup('.grid-deals', {
        animation: {
            animateResizeContainer: false
        }
    });

    mixer.filter('.year2025');
}

